import { apiClient } from './client.tsx';

import type {
  CreateRefuelingContractRequest,
  UpdateRefuelingContractRequest,
  DownloadRefuelingContractAttachmentRequest,
  UploadRefuelingContractAttachmentRequest,
  DeleteRefuelingContractAttachmentRequest,
  PublishRefuelingContractRequest,
} from './requests/refueling-contract-request.ts';

import type {
  CreateRefuelingContractResponse,
  DownloadUrlResponse,
} from './responses/refueling-contract-response.ts';

import type { RefuelingContract } from '../models/refueling-contract.ts';

export const fetchRefuelingContract = (partnerId: string, id: string) =>
  apiClient
    .get<{
      data: RefuelingContract;
    }>(`/v2/partners/${partnerId}/refueling_contracts/${id}`)
    .then((res) => res.data);

export const createRefuelingContract = ({
  partnerId,
  ...restReq
}: CreateRefuelingContractRequest) =>
  apiClient
    .post<CreateRefuelingContractResponse>(
      `/v2/partners/${partnerId}/refueling_contracts`,
      restReq,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data);

export const updateRefuelingContract = ({
  partnerId,
  id,
  ...restReq
}: UpdateRefuelingContractRequest) =>
  apiClient
    .put<string>(`/v2/partners/${partnerId}/refueling_contracts/${id}`, restReq)
    .then((res) => res.data);

export const downloadRefuelingContractAttachment = ({
  partnerId,
  contractId,
  attachmentId,
}: DownloadRefuelingContractAttachmentRequest) =>
  apiClient
    .get<DownloadUrlResponse>(
      `/v2/partners/${partnerId}/refueling_contracts/${contractId}/attachments/${attachmentId}/get_download_url`,
    )
    .then((res) => res.data);

export const uploadRefuelingAttachment = ({
  partnerId,
  contractId,
  ...restReq
}: UploadRefuelingContractAttachmentRequest) =>
  apiClient
    .post<string>(
      `/v2/partners/${partnerId}/refueling_contracts/${contractId}/upload`,
      restReq,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data);

export const deleteRefuelingAttachment = ({
  partnerId,
  contractId,
  attachmentId,
}: DeleteRefuelingContractAttachmentRequest) =>
  apiClient
    .delete<string>(
      `/v2/partners/${partnerId}/refueling_contracts/${contractId}/attachments/${attachmentId}`,
    )
    .then((res) => res.data);

export const publishRefuelingContract = ({
  partnerId,
  id,
}: PublishRefuelingContractRequest) =>
  apiClient
    .post<string>(`/v2/partners/${partnerId}/refueling_contracts/${id}/publish`)
    .then((res) => res.data);
